const chordsMajor = [
  { C: ["C", "E", "G"] },
  { "C#": ["C#", "E#", "G#"] },
  { "D♭": ["Db", "F", "Ab"] },
  { D: ["D", "F#", "A"] },
  { "D#": ["D#", "G", "A#"] },
  { "E♭": ["Eb", "G", "Bb"] },
  { E: ["E", "G#", "B"] },
  { F: ["F", "A", "C"] },
  { "F#": ["F#", "A#", "C#"] },
  { "G♭": ["Gb", "Bb", "Db"] },
  { G: ["G", "B", "D"] },
  { "G#": ["G#", "C", "D#"] },
  { "A♭": ["Ab", "C", "Eb"] },
  { A: ["A", "C#", "E"] },
  { "A#": ["A#", "D", "F"] },
  { "B♭": ["Bb", "D", "F"] },
  { B: ["B", "D#", "F#"] },
];
const chordsMajor1Inversion = [
  { "C/E": ["E", "G", "C"] },
  { "C#/E#": ["E#", "G#", "C#"] },
  { "D♭/F": ["F", "Ab", "Db"] },
  { "D/F#": ["F#", "A", "D"] },
  { "D#/G": ["G", "A#", "D#"] },
  { "E♭/G": ["G", "Bb", "Eb"] },
  { "E/G#": ["G#", "B", "E"] },
  { "F/A": ["A", "C", "F"] },
  { "F#/A#": ["A#", "C#", "F#"] },
  { "G♭/Bb": ["Bb", "Db", "Gb"] },
  { "G/B": ["B", "D", "G"] },
  { "G#/C": ["C", "D#", "G#"] },
  { "A♭/C": ["C", "Eb", "Ab"] },
  { "A/C#": ["C#", "E", "A"] },
  { "A#/D": ["D", "F", "A#"] },
  { "B♭/D": ["D", "F", "Bb"] },
  { "B/D#": ["D#", "F#", "B"] },
];
const chordsMajor2Inversion = [
  { "C/G": ["G", "C", "E"] },
  { "C#/G#": ["G#", "C#", "E#"] },
  { "D♭/Ab": ["Ab", "Db", "F"] },
  { "D/A": ["A", "D", "F#"] },
  { "D#/A#": ["A#", "D#", "G"] },
  { "E♭/Bb": ["Bb", "Eb", "G"] },
  { "E/B": ["B", "E", "G#"] },
  { "F/C": ["C", "F", "A"] },
  { "F#/C#": ["C#", "F#", "A#"] },
  { "G♭/Db": ["Db", "Gb", "Bb"] },
  { "G/D": ["D", "G", "B"] },
  { "G#/D#": ["D#", "G#", "C"] },
  { "A♭/Eb": ["Eb", "Ab", "C"] },
  { "A/E": ["E", "A", "C#"] },
  { "A#/F": ["F", "A#", "D"] },
  { "B♭/F": ["F", "Bb", "D"] },
  { "B/F#": ["F#", "B", "D#"] },
];

const chordsMinor = [
  { Cm: ["C", "Eb", "G"] },
  { "C#m": ["C#", "E", "G#"] },
  { "D♭m": ["Db", "E", "Ab"] },
  { Dm: ["D", "F", "A"] },
  { "D#m": ["D#", "F#", "A#"] },
  { "E♭m": ["Eb", "Gb", "Bb"] },
  { Em: ["E", "G", "B"] },
  { Fm: ["F", "Ab", "C"] },
  { "F#m": ["F#", "A", "C#"] },
  { "G♭m": ["Gb", "A", "Db"] },
  { Gm: ["G", "Bb", "D"] },
  { "G#m": ["G#", "B", "D#"] },
  { "A♭m": ["Ab", "Cb", "Eb"] },
  { Am: ["A", "C", "E"] },
  { "A#m": ["A#", "C#", "F"] },
  { "B♭m": ["Bb", "Db", "F"] },
  { Bm: ["B", "D", "F#"] },
];
const chordsMinor1Inversion = [
  { "Cm/Eb": ["Eb", "G", "C"] },
  { "C#m/E": ["E", "G#", "C#"] },
  { "D♭m/E": ["E", "Ab", "Db"] },
  { "Dm/F": ["F", "A", "D"] },
  { "D#m/F#": ["F#", "A#", "D#"] },
  { "E♭m/Gb": ["Gb", "Bb", "Eb"] },
  { "Em/G": ["G", "B", "E"] },
  { "Fm/Ab": ["Ab", "C", "F"] },
  { "F#m/A": ["A", "C#", "F#"] },
  { "G♭m/A": ["A", "Db", "Gb"] },
  { "Gm/Bb": ["Bb", "D", "G"] },
  { "G#m/B": ["B", "D#", "G#"] },
  { "A♭m/Cb": ["Cb", "Eb", "Ab"] },
  { "Am/C": ["C", "E", "A"] },
  { "A#m/C#": ["C#", "F", "A#"] },
  { "B♭m/Db": ["Db", "F", "Bb"] },
  { "Bm/D": ["D", "F#", "B"] },
];
const chordsMinor2Inversion = [
  { "Cm/G": ["G", "C", "Eb"] },
  { "C#m/G#": ["G#", "C#", "E"] },
  { "D♭m/Ab": ["Ab", "Db", "E"] },
  { "Dm/A": ["A", "D", "F"] },
  { "D#m/A#": ["A#", "D#", "F#"] },
  { "E♭m/Bb": ["Bb", "Eb", "Gb"] },
  { "Em/B": ["B", "E", "G"] },
  { "Fm/C": ["C", "F", "Ab"] },
  { "F#m/C#": ["C#", "F#", "A"] },
  { "G♭m/Db": ["Db", "Gb", "A"] },
  { "Gm/D": ["D", "G", "Bb"] },
  { "G#m/D#": ["D#", "G#", "B"] },
  { "A♭m/Eb": ["Eb", "Ab", "Cb"] },
  { "Am/E": ["E", "A", "C"] },
  { "A#m/F": ["F", "A#", "C#"] },
  { "B♭m/F": ["F", "Bb", "Db"] },
  { "Bm/F#": ["F#", "B", "D"] },
];

const chordsDim = [
  { Cdim: ["C", "Eb", "Gb"] },
  { "C#dim": ["C#", "E", "G"] },
  { "D♭dim": ["Db", "E", "G"] },
  { Ddim: ["D", "F", "Ab"] },
  { "D#dim": ["D#", "F#", "A"] },
  { "E♭dim": ["Eb", "Gb", "A"] },
  { Edim: ["E", "G", "Bb"] },
  { Fdim: ["F", "Ab", "Cb"] },
  { "F#dim": ["F#", "A", "C"] },
  { "G♭dim": ["Gb", "A", "C"] },
  { Gdim: ["G", "Bb", "Db"] },
  { "G#dim": ["G#", "B", "D"] },
  { "A♭dim": ["Ab", "Cb", "D"] },
  { Adim: ["A", "C", "Eb"] },
  { "A#dim": ["A#", "C#", "E"] },
  { "B♭dim": ["Bb", "Db", "Fb"] },
  { Bdim: ["B", "D", "F"] },
];

const chordsAugm = [
  { "C♭aug": ["Cb", "Eb", "G"] },
  { Caug: ["C", "E", "G#"] },
  { "C#aug": ["C#", "F", "A"] },
  { "D♭aug": ["Db", "F", "A"] },
  { Daug: ["D", "F#", "A#"] },
  { "D#aug": ["D#", "G", "B"] },
  { "E♭aug": ["Eb", "G", "B"] },
  { Eaug: ["E", "G#", "B#"] },
  { "E#aug": ["E#", "A", "C#"] },
  { "F♭aug": ["Fb", "Ab", "C"] },
  { Faug: ["F", "A", "C#"] },
  { "F#aug": ["F#", "A#", "D"] },
  { "G♭aug": ["Gb", "Bb", "D"] },
  { Gaug: ["G", "B", "D#"] },
  { "G#aug": ["G#", "C", "E"] },
  { "A♭aug": ["Ab", "C", "E"] },
  { Aaug: ["A", "C#", "E#"] },
  { "A#aug": ["A#", "D", "F#"] },
  { "B♭aug": ["Bb", "D", "F#"] },
  { Baug: ["B", "D#", "G"] },
  { "B#aug": ["B#", "E", "G#"] },
];

export const namesChords = [
  { "Major Chords": chordsMajor },
  { "Major Chords 1st inversion": chordsMajor1Inversion },
  { "Major Chords 2nd inversion": chordsMajor2Inversion },
  { "Minor Chords": chordsMinor },
  { "Minor Chords 1st inversion": chordsMinor1Inversion },
  { "Minor Chords 2nd inversion": chordsMinor2Inversion },
  { "Diminished Chords": chordsDim },
  { "Augmented Chords": chordsAugm },
];
